import React from "react";
import LinkSlider from "../Components/LinkSlider";
import { motion } from "framer-motion";
import Contactus from "../Components/Contactus";
import Faq from "../Components/Faq";
import { SubscribeSection } from "../Components/SubscribeSection";
import { useLanguage } from "../Router/LanguageContext";
import PeopleSafetyExecution from "../Components/PeopleSafetyExecution";

export default function Esgcommitment() {
  const { dictionary } = useLanguage();

  const ourMission = {
    title: dictionary?.environmentalTitle,
    description: dictionary?.environmentalDescMain,
    arrayData: dictionary?.environmentalPoints || [],
    img1: "/assets/img/SocialImages.png",
    img2: "/assets/img/SocialImageFrame.png",
  };

  const ourVision = {
    title: dictionary?.socialTitle,
    description: dictionary?.socialDescMain,
    arrayData: dictionary?.socialPoints || [],
    img1: "/assets/img/Union1.png",
    img2: "/assets/img/Union2.png",
  };

  const executionCapability = {
    title: dictionary?.governanceTitle,
    description: dictionary?.governanceDescMain,
    arrayData: dictionary?.governancePoints || [],
    img1: "/assets/img/Governance.png",
    img2: "/assets/img/GovernanceEffect.png",
  };

  return (
    <>
      <div className="gridSection commonHeaderPadding">
        <div className="container-fluid maxContainerSection">
          <div className="row">
            <div className="col-md-12">
              <div className="egsSectionMain">
                <div className="egsSectionHeader">
                  <h3 className="m-0 f-s-48">
                    {dictionary?.esgCommitmentTitle}
                  </h3>
                  <p className="m-0 f-s-20">{dictionary?.esgCommitmentDesc}</p>
                  {/* <button className="radius-btn">
                    <span className="btn-text">Contact us</span>
                  </button> */}
                </div>
                <div className="egsImageSection">
                  <img
                    src="/assets/img/esgHeroImage.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LinkSlider />

      <div className="section section-who-we-are">
        <div className="container-fluid maxContainerSection mobile-contain-padding">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-8 text-center col-block-top">
              <h2 className="m-0 f-w-600 f-s-48 block-title block-titleBold">
                {dictionary?.esgPillarsTitle}
              </h2>
              <p className="m-0 f-s-20 block-desc">
                {dictionary?.esgPillarsDesc}
              </p>
            </div>
          </div>

          <div className="row ourSolutionSection row-solution-about-us">
            <div className="col-md-6">
              <div className="energySectorImage">
                <motion.img
                  src={ourMission?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={ourMission?.img2}
                  className="img-fluid energySectorEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {ourMission.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {ourMission?.description}
              </motion.p>
              <ul className="mission-list">
                {ourMission?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row ourSolutionSection row-solution-about-us flex-column-reverse flex-md-row row-vision">
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {ourVision.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {ourVision?.description}
              </motion.p>
              <ul className="mission-list">
                {ourVision?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>

            <div className="col-md-6 energySectorImage">
              <div className="energySectorImage">
                <motion.img
                  src={ourVision?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={ourVision?.img2}
                  className="img-fluid energySectorEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
          </div>

          <div className="row row-solution-about-us">
            <div className="col-md-6">
              <div className="energySectorImage">
                <motion.img
                  src={executionCapability?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={executionCapability?.img2}
                  className="img-fluid energySectorEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {executionCapability.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {executionCapability?.description}
              </motion.p>
              <ul className="mission-list">
                {executionCapability?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="whoweareoutersection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection">
              <h2 className="m-0 f-s-48">
                {dictionary?.esgQuote}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <PeopleSafetyExecution/>

      <div className="section-main-contact-us">
        <div className="container-fluid maxContainerSection commonPadding pb-0">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.getInTouchTitle}</h2>
              <p className="m-0 f-s-20 ">{dictionary?.getInTouchDesc}</p>
            </div>
          </div>
          <Contactus />
        </div>
      </div>
      <Faq />
      <SubscribeSection />
    </>
  );
}
